import { render, staticRenderFns } from "./RequestedLink.vue?vue&type=template&id=0e4c533b&scoped=true"
import script from "./RequestedLink.vue?vue&type=script&lang=js"
export * from "./RequestedLink.vue?vue&type=script&lang=js"
import style0 from "./RequestedLink.vue?vue&type=style&index=0&id=0e4c533b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4c533b",
  null
  
)

export default component.exports